// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import TickerBar from "./components/TickerBar";
import Home from "./pages/Home";
import BinScreen from "./pages/BinScreen";

function AppLayout() {
  const location = useLocation();
  const isBinScreen = location.pathname.startsWith("/bin");

  return (
    <div className="flex flex-col h-screen w-screen">
      {!isBinScreen && <Header />}
      {!isBinScreen && <TickerBar />}

      {isBinScreen ? (
        // Fullscreen bin screen — no main wrapper
        <Routes>
          <Route path="/bin/:hallName" element={<BinScreen />} />
        </Routes>
      ) : (
        // Regular layout with main, background, padding, etc.
        <main className="flex-1 bg-[#F6F8D0] overflow-y-auto flex justify-center items-start p-8">
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
      )}

      {!isBinScreen && <Footer />}
    </div>
  );
}


function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
